import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMatchRoute } from '@repo/app-router';
import { SidebarMenuButton, SidebarMenuItem, SidebarMenuSub, SidebarMenuSubButton, SidebarMenuSubItem } from '@repo/ui-primitives/sidebar';
import { Skeleton } from '@repo/ui-primitives/skeleton';
import { cn } from '@repo/ui-primitives/utils';
import { ChevronRight, Folder, FolderOpen, Package } from 'lucide-react';
import { useGetProjectApplicationSidebarList } from 'ze-sdk';
import { NavLink } from '../../../components/nav-link';
export function ProjectItem(param) {
    let { project, organization, isExpanded, onToggle } = param;
    var _ref;
    const matchRoute = useMatchRoute();
    const isProjectActive = matchRoute({
        to: "/org/$organization/$project",
        params: {
            organization,
            project: project.name
        },
        fuzzy: true
    });
    const { data: applicationListResponse, isLoading, refetch, isFetched } = useGetProjectApplicationSidebarList({
        organization,
        project: project.name
    }, {
        query: {
            enabled: isExpanded
        }
    });
    const applicationList = (_ref = applicationListResponse === null || applicationListResponse === void 0 ? void 0 : applicationListResponse.entities) !== null && _ref !== void 0 ? _ref : [];
    const fetchIfNeeded = ()=>{
        if (!isFetched) {
            refetch().catch(()=>{
                // eslint-disable-next-line no-console
                console.error('Failed to fetch application list on expand');
            });
        }
    };
    return /*#__PURE__*/ _jsxs(SidebarMenuItem, {
        children: [
            /*#__PURE__*/ _jsxs(SidebarMenuButton, {
                onMouseOver: ()=>{
                    fetchIfNeeded();
                },
                onClick: onToggle,
                "data-active": isProjectActive,
                className: "group/collapsible font-bold",
                children: [
                    /*#__PURE__*/ _jsx(ChevronRight, {
                        className: "h-4 w-4 transition-transform  ".concat(isExpanded ? 'rotate-90' : '')
                    }),
                    isExpanded ? /*#__PURE__*/ _jsx(FolderOpen, {
                        className: "h-4 w-4 "
                    }) : /*#__PURE__*/ _jsx(Folder, {
                        className: "h-4 w-4 "
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: cn('truncate font-semibold'),
                        children: project.displayName
                    })
                ]
            }),
            isExpanded && /*#__PURE__*/ _jsx(SidebarMenuSub, {
                children: isLoading ? /*#__PURE__*/ _jsx(SidebarMenuSubItem, {
                    children: /*#__PURE__*/ _jsx(Skeleton, {
                        className: "h-6 w-full"
                    })
                }) : applicationList === null || applicationList === void 0 ? void 0 : applicationList.sort((a, b)=>a.name.localeCompare(b.name)).map((app)=>{
                    return /*#__PURE__*/ _jsx(SidebarMenuSubItem, {
                        children: /*#__PURE__*/ _jsx(SidebarMenuSubButton, {
                            asChild: true,
                            children: /*#__PURE__*/ _jsx(NavLink, {
                                to: "/org/$organization/$project/$application/",
                                params: {
                                    organization,
                                    project: project.name,
                                    application: app.name
                                },
                                activeProps: {
                                    className: 'text-brand-300 hover:text-brand-300 transition-all duration-200'
                                },
                                inactiveProps: {
                                    className: 'text-gray-200/70'
                                },
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: cn('flex items-center gap-1.5 font-light'),
                                    children: [
                                        /*#__PURE__*/ _jsx(Package, {
                                            className: "h-4 w-4 "
                                        }),
                                        /*#__PURE__*/ _jsx("p", {
                                            className: "truncate",
                                            children: app.name
                                        })
                                    ]
                                })
                            })
                        })
                    }, app.id);
                })
            })
        ]
    });
}
